import { render, staticRenderFns } from "./ICAModal.vue?vue&type=template&id=29fb54a6&"
import script from "./ICAModal.vue?vue&type=script&lang=js&"
export * from "./ICAModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports